import svg4everybody from 'svg4everybody';

jQuery(document).ready(function ($) {
	$.main = {
		init: function () {
			try {
				$.browser.init();
				$.resizer.init();
				$.slider.init();
				$.navigation.init();
				$.search.init();
				$.accordion.init();
				$.misc.init();
				$.maps.init();
				$.loadmore.init();
				// $.cookiehint.init();
				$.lightgallery.init();
				$.anchors.init();
				$.tabs.init();
				$.parallax.init();
				$.friendlycaptcha.init();
			} catch (e) {
				console.log(e);
			}
		},

		handler: function (eventobjekt) {
			if (!eventobjekt) {
				eventobjekt = window.event;
			}
		}
	};
	$.main.init();
});
